import { api } from "../config/api";

const LOGIN = `auth/login`;

export const login = (user) => api.post(LOGIN, user);
export const logout = (refreshToken) =>
  api.delete(`auth/logout/?refreshToken=${refreshToken}`);
